import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const tenantApi = axios.create({ baseURL: API, timeout: 30000 });

// Mirror the tenant header injection that lib/api.js does, in case future code
// uses tenantApi for non-tenant-prefixed routes.
tenantApi.interceptors.request.use((config) => {
  try {
    const raw = sessionStorage.getItem("plena_tenant");
    if (raw) {
      const t = JSON.parse(raw);
      if (t?.slug && !config.headers["X-Tenant-Slug"]) {
        config.headers["X-Tenant-Slug"] = t.slug;
      }
    }
  } catch {
    // ignore
  }
  return config;
});

// ---------- Helpers ----------
export const getActiveTenant = () => {
  try {
    const raw = sessionStorage.getItem("plena_tenant");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getActiveTenantSlug = () => getActiveTenant()?.slug || null;

// ---------- Tenant sector endpoints ----------
export const fetchTenantLibrary = (slug) =>
  tenantApi.get(`/tenants/${slug}/library`).then((r) => r.data);

export const fetchTenantCareerLadders = (slug) =>
  tenantApi.get(`/tenants/${slug}/career-ladders`).then((r) => r.data.items);

export const fetchTenantEmployees = (slug, params = {}) =>
  tenantApi.get(`/tenants/${slug}/employees`, { params }).then((r) => r.data);

export const fetchTenantEmployee = (slug, empId) =>
  tenantApi.get(`/tenants/${slug}/employees/${empId}`).then((r) => r.data);

export const fetchTenantBranches = (slug) =>
  tenantApi.get(`/tenants/${slug}/branches`).then((r) => r.data.items);

export const fetchTenantSummary = (slug) =>
  tenantApi.get(`/tenants/${slug}/summary`).then((r) => r.data);

export const fetchTenantEmpSales = (slug, empId) =>
  tenantApi.get(`/tenants/${slug}/sales-performance/${empId}`).then((r) => r.data.items);

export const fetchTenantEmpTraining = (slug, empId) =>
  tenantApi.get(`/tenants/${slug}/training/${empId}`).then((r) => r.data.items);

export const fetchTenantSkillGap = (slug, empId, targetRoleId) =>
  tenantApi
    .get(`/tenants/${slug}/employees/${empId}/skill-gap`, {
      params: targetRoleId ? { target_role_id: targetRoleId } : {},
    })
    .then((r) => r.data);

export const fetchTenantPersonas = (slug) =>
  tenantApi
    .get(`/personas`, { headers: { "X-Tenant-Slug": slug } })
    .then((r) => r.data.personas);
